import { c as _c } from "react/compiler-runtime";
import Button from "@components/blocks/Button";
import CardButton from "@components/blocks/CardButton";
import Section from "@components/Section";
import SimpleRichText from "@components/SimpleRichText";
import { getSerifClass, isInverted } from "@components/utilities";
import { Title } from "@justhome/react-ui";
import clsx from "clsx";
import { FC } from "react";
import Icon from "./Icon";
import TextItems from "./TextItems";
import { CtaWithTextProps } from "./types";
const SecondVariant: FC<CtaWithTextProps> = t0 => {
  const $ = _c(53);
  const {
    data
  } = t0;
  const background = data.background;
  let T0;
  let T1;
  let inverted;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== background || $[1] !== data) {
    inverted = isInverted(background);
    T1 = Section;
    t6 = data;
    t7 = "pb-m my-2s m:my-3s grid gap gap-y-none grid-cols-1 m:grid-cols-12";
    if ($[13] !== data.icon) {
      t8 = data.icon && <div className="m:col-span-12"><Icon icon={data.icon} /></div>;
      $[13] = data.icon;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    t5 = "col-span-1 m:col-span-6 order-2 m:order-1";
    t4 = "mb-m m:mb-2m";
    T0 = Title;
    t1 = inverted;
    if ($[15] !== background) {
      t2 = getSerifClass(background);
      $[15] = background;
      $[16] = t2;
    } else {
      t2 = $[16];
    }
    t3 = clsx("text-d3", {
      "text-neutral-0": inverted
    });
    $[0] = background;
    $[1] = data;
    $[2] = T0;
    $[3] = T1;
    $[4] = inverted;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    T0 = $[2];
    T1 = $[3];
    inverted = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[17] !== T0 || $[18] !== data.title || $[19] !== t1 || $[20] !== t2 || $[21] !== t3) {
    t9 = <T0 inverted={t1} serifClass={t2} className={t3}>{data.title}</T0>;
    $[17] = T0;
    $[18] = data.title;
    $[19] = t1;
    $[20] = t2;
    $[21] = t3;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t4 || $[24] !== t9) {
    t10 = <div className={t4}>{t9}</div>;
    $[23] = t4;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== data.subTitle || $[27] !== inverted) {
    t11 = data.subTitle && <p className={clsx("text-body-1", {
      "text-neutral-0": inverted
    })}>{data.subTitle}</p>;
    $[26] = data.subTitle;
    $[27] = inverted;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== data.cardButton) {
    t12 = data.cardButton && <CardButton {...data.cardButton} />;
    $[29] = data.cardButton;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== data.button) {
    t13 = data.button && <Button {...data.button} />;
    $[31] = data.button;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t12 || $[34] !== t13) {
    t14 = <div className="mt-3s mb-s">{t12}{t13}</div>;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== data.textItems) {
    t15 = <TextItems items={data.textItems} />;
    $[36] = data.textItems;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t10 || $[39] !== t11 || $[40] !== t14 || $[41] !== t15 || $[42] !== t5) {
    t16 = <div className={t5}>{t10}{t11}{t14}{t15}</div>;
    $[38] = t10;
    $[39] = t11;
    $[40] = t14;
    $[41] = t15;
    $[42] = t5;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== data.body) {
    t17 = <div className="m:col-span-5 m:col-start-8 order-1 m:order-2 py-3m m:py-none"><SimpleRichText>{data.body}</SimpleRichText></div>;
    $[44] = data.body;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== T1 || $[47] !== t16 || $[48] !== t17 || $[49] !== t6 || $[50] !== t7 || $[51] !== t8) {
    t18 = <T1 section={t6} className={t7}>{t8}{t16}{t17}</T1>;
    $[46] = T1;
    $[47] = t16;
    $[48] = t17;
    $[49] = t6;
    $[50] = t7;
    $[51] = t8;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  return t18;
};
export default SecondVariant;